import Link from "@/components/elements/LinkComponent";

import { appendDateToCopyright } from "@/base/helpers/appendDateToCopyright";
import * as styles from "./styles.module.scss";

export function FooterCopyright({
  copyrights_menu,
  copyrights_title,
}: Pick<FooterTemplate, "copyrights_menu" | "copyrights_title">) {
  return (
    <div className={styles.footerCopyright}>
      <p> {appendDateToCopyright(copyrights_title)}</p>
      {Array.isArray(copyrights_menu) && (
        <ul className={styles.copyrightsMenu}>
          {copyrights_menu.map((link) => (
            <li key={link.title}>
              <Link type={link.type} url={link.url}>
                {link.title}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
